import { observer } from 'mobx-react-lite';

import { OpponentVideo } from '@gem/call/CallView/Shared/OpponentVideo/OpponentVideo';
import { AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';

import { OpponentList } from './OpponentList/OpponentList';
import { SharedScreen } from './SharedScreen/SharedScreen';
import { useSpeakerVideoPresenter } from './SpeakerVideo.presenter';
import styles from './SpeakerVideo.styles.m.css';

export const SpeakerVideo = observer(() => {
  const presenter = useSpeakerVideoPresenter();

  return (
    <div className={styles.container}>
      <div className={styles.speaker}>
        {presenter.isShowScreenShare && <SharedScreen />}

        {presenter.isShowOpponentVideo && (
          <OpponentVideo
            key={presenter.activeOpponent.uid}
            opponent={presenter.activeOpponent}
            avatarType={AvatarTypes.Round_50}
            isHighlightAudio
            containerClassName={styles.videoContainer}
          />
        )}
      </div>
      {presenter.hasPreviewOpponents && <OpponentList />}
    </div>
  );
});
